define([
    'jquery',
    'lodash/object/assign',
    'jquery-hammerjs'
], function ($, assign, hammer) {
    'use strict';
    var Twitter = function (options) {
        this.hashtag = options.ht;
        this.appendTo = options.classAppend;
        this.proxyUrl = options.proxyUrl;
        this.initialize();
    };
    assign(Twitter.prototype, {
        oldPage: 1,
        currentPage: 1,
        hashtag: '',
        numTweets: 9,
        appendTo: '',
        initialize: function () {
             //navigation and twitter-info
            $(this.appendTo).after('<nav><div class="twit-nav"></div></nav>');
            $(this.appendTo).parent().after('<div class="twitter-info"><div><p>Use <a href="twitterlink" target="_blank"><strong class="twit-hashtag"></strong></a> to leave a message via twitter</p></div></div>');
            //Change hashtag in twitter info
            var ht = this.hashtag.replace('%23', '#');
            $('.twit-hashtag').text(ht);
            //Change link to chosen hashtag
            $('a[href="twitterlink"]').attr('href', 'http://www.twitter.com/home?status=' + this.hashtag);
            this.loadTweets();
        },
        loadTweets: function () {
            var self = this;
            $.ajax({
                url: this.proxyUrl,
                type: 'GET',
                dataType: 'json',
                timeout: 5000,
                success: function (data, textStatus, xhr) {
                    var retrievedData = [], singleUserData = [], i;
                    for (i = 0; i < data.results.length; i += 1) {
                        singleUserData = {};
                        singleUserData.profilelink = data.results[i].from_user;
                        singleUserData.imagesource = data.results[i].profile_image_url;
                        singleUserData.tweettext = Twitter.prototype.ify.clean(data.results[i].text);
                        singleUserData.fromfullname = data.results[i].from_user_name;
                        singleUserData.fromuser = data.results[i].from_user;
                        singleUserData.ago = Twitter.prototype.relativeTime(data.results[i].created_at);
                        retrievedData[i] = singleUserData;
                    }
                    self.generatePages(retrievedData);
                    setTimeout(this.loadTweets, 600000);
                },
                error: function (jqXHR, textStatus, error) {
                    $(self.appendTo).append("<p>Couldn't reach the Twitter server. Please try again later.</p>");
                }
            });
        },
        generatePages: function (data) {
            var pageCount = 1,
                ht = this.hashtag;
            if (data.length === 0) {
                $('.twitter-info').addClass('notweets');
                $('.notweets').text("");
                $('.notweets').append('<div><p>No tweets posted yet! Use <a href="twitterlink" target="_blank"><strong class="twit-hashtag"></strong></a> to leave a message via Twitter.</p></div>');
                ht = ht.replace('%23', '#');
                $('.twit-hashtag').text(ht);
                //Change link to chosen hashtag
                $('a[href="twitterlink"]').attr('href', 'http://www.twitter.com/home?status=' + this.hashtag);
            }
            if (data.length < 4) {
                pageCount = 1;
                this.addTweets(data, pageCount);
            } else if (data.length > 3 && data.length < 7) {
                pageCount = 2;
                $('.twit-nav').empty();
                $('.twit-nav').append('<a href="javascript:;" class="twit-page1"></a><a href="javascript:;" class="twit-page2"></a>');
                this.addTweets(data, pageCount);
            } else if (data.length > 6) {
                pageCount = 3;
                $('.twit-nav').empty();
                $('.twit-nav').append('<a href="javascript:;" class="twit-page1"></a><a href="javascript:;" class="twit-page2"></a><a href="javascript:;" class="twit-page3"></a>');
                this.addTweets(data, pageCount);
            }
            this.generateClickHandlers(data, pageCount);
        },
        /*Twitter navigation*/
        generateClickHandlers: function (data, pages) {
            var self = this, page1, page2, page3;
            if (pages === 2) {
                page1 = $('.twit-page1');
                page2 = $('.twit-page2');
            }
            if (pages === 3) {
                page1 = $('.twit-page1');
                page2 = $('.twit-page2');
                page3 = $('.twit-page3');
            }
            if (page1 !== undefined) {
                page1.click(function () {
                    self.oldPage = self.currentPage;
                    self.currentPage = 1;
                    var diff = self.oldPage - self.currentPage;
                    self.animate(diff, data, pages);
                });
            }
            if (page2 !== undefined) {
                page2.click(function () {
                    self.oldPage = self.currentPage;
                    self.currentPage = 2;
                    var diff = self.oldPage - self.currentPage;
                    self.animate(diff, data, pages);
                });
            }
            if (page3 !== undefined) {
                page3.click(function () {
                    self.oldPage = self.currentPage;
                    self.currentPage = 3;
                    var diff = self.oldPage - self.currentPage;
                    self.animate(diff, data, pages);
                });
            }
            $('.jstwitter').hammer().on('swipe', function (event) {
                if (event.gesture.direction === 'left') {
                    if (pages === 3) {
                        if (self.currentPage !== 3) {
                            self.oldPage = self.currentPage;
                            self.currentPage += 1;
                            self.animate(-1, data, pages);
                        }
                    }
                    if (pages === 2) {
                        if (self.currentPage !== 2) {
                            self.oldPage = self.currentPage;
                            self.currentPage += 1;
                            self.animate(-1, data, pages);
                        }
                    }
                }
                if (event.gesture.direction === 'right') {
                    if (self.currentPage !== 1) {
                        self.oldPage = self.currentPage;
                        self.currentPage -= 1;
                        self.animate(1, data, pages);
                    }
                }
            });
        },
        animate: function (diff, data, pages) {
            //Set Navigation
            var self = this, i;
            for (i = 1; i < pages + 1; i += 1) {
                $('.twit-page' + i).removeClass('active');
            }
            $('.twit-page' + this.currentPage).addClass('active');
            if (diff === 1) {
                $('.jstwitter').animate({
                    opacity: '0',
                    left: '+=200'
                }, 100, function () {
                    $('.jstwitter').empty();
                    $('.jstwitter').css({
                        left: '-=500'
                    });
                    $('.jstwitter').animate({
                        opacity: 1,
                        left: '+=300'
                    });
                    self.addTweets(data, pages);
                });
            }
            if (diff === -1) {
                $('.jstwitter').animate({
                    opacity: '0',
                    left: '-=200'
                }, 100, function () {
                    $('.jstwitter').empty();
                    $('.jstwitter').css({
                        left: '+=500'
                    });
                    $('.jstwitter').animate({
                        opacity: 1,
                        left: '-=300'
                    });
                    self.addTweets(data, pages);
                });
            }
            if (diff === 2) {
                $('.jstwitter').animate({
                    opacity: '0',
                    left: '+=200'
                }, 100, function () {
                    $('.jstwitter').empty();
                    $('.jstwitter').css({
                        left: '-=500'
                    });
                    $('.jstwitter').animate({
                        opacity: 1,
                        left: '+=300'
                    });
                    self.addTweets(data, pages);
                });
            }
            if (diff === -2) {
                $('.jstwitter').animate({
                    opacity: '0',
                    left: '-=200'
                }, 100, function () {
                    $('.jstwitter').empty();
                    $('.jstwitter').css({
                        left: '+=500'
                    });
                    $('.jstwitter').animate({
                        opacity: 1,
                        left: '-=300'
                    });
                    self.addTweets(data, pages);
                });
            }
        },
        addTweets: function (data, pages) {
            var self = this, i;
            $('.jstwitter').empty();
            if (this.currentPage === 1) {
                $('.twit-page1').addClass('active');
            }
            if (this.currentPage === 2) {
                $('.twit-page2').addClass('active');
            }
            if (this.currentPage === 3) {
                $('.twit-page3').addClass('active');
            }
            if (pages === 1) {
                for (i = 0; i < data.length; i += 1) {
                    self.appendTweets(data, i);
                }
            }
            if (pages === 2) {
                if (this.currentPage === 1) {
                    for (i = 0; i < 3; i += 1) {
                        self.appendTweets(data, i);
                    }
                }
                if (this.currentPage === 2) {
                    for (i = 3; i < 6; i += 1) {
                        self.appendTweets(data, i);
                    }
                }
            }
            if (pages === 3) {
                if (this.currentPage === 1) {
                    for (i = 0; i < 3; i += 1) {
                        self.appendTweets(data, i);
                    }
                }
                if (this.currentPage === 2) {
                    for (i = 3; i < 6; i += 1) {
                        self.appendTweets(data, i);
                    }
                }
                if (this.currentPage === 3) {
                    for (i = 6; i < 9; i += 1) {
                        self.appendTweets(data, i);
                    }
                }
            }
        },
        appendTweets: function (data, i) {

            var html = ' <article><a href="PROFILELINK" target="_blank"><img src="IMGSOURCE" alt="FROMUSER twitter avatar" /></a><div class="comment-content"><div class="arrow"></div><header><h5><a href="PROFILELINK" target="_blank">FROMUSERFULLNAME</a></h5><p class="twit-timestamp">AGO</p></header><p>TWEET_TEXT</p></div></article>';
            if (data[i] !== undefined) {
                $(this.appendTo).append(
                    html.replace(/PROFILELINK/g, 'http://twitter.com/' + data[i].fromuser).replace('IMGSOURCE', data[i].imagesource).replace('TWEET_TEXT', data[i].tweettext).replace('FROMUSERFULLNAME', data[i].fromfullname).replace(/FROMUSER/g, data[i].fromuser).replace('AGO', data[i].ago)
                );
            }
        },
        relativeTime: function (userDate) {
            var currentTime = new Date(), postTime = new Date(userDate), diff = currentTime - postTime, second = 1000, minute = second * 60, hour = minute * 60, day = hour * 24;
            if (isNaN(diff) || diff < 0) {
                return '';
            }
            if (diff < second * 5) {
                return 'right now';
            }
            if (diff < minute) {
                return Math.floor(diff / second) + ' seconds ago';
            }
            if (diff < minute * 2) {
                return 'about 1 minute ago';
            }
            if (diff < hour) {
                return Math.floor(diff / minute) + ' minutes ago';
            }
            if (diff < hour * 2) {
                return 'about 1 hour ago';
            }
            if (diff < day) {
                return Math.floor(diff / hour) + ' hours ago';
            }
            if (diff > day && diff < day * 2) {
                return 'yesterday';
            }
            if (diff < day * 365) {
                return Math.floor(diff / day) + ' days ago';
            }
        },
        ify: {
            link: function (tweet) {
                return tweet.replace(/\b(((https*\:\/\/)|www\.)[^\"\']+?)(([!?,.\)]+)?(\s|$))/g, function (link, m1, m2, m3, m4) {
                    var http = m2.match(/w/) ? 'http://' : '';
                    return '<a class="twit-hyperlink" target="_blank" href="' + http + m1 + '">' + ((m1.length > 25) ? m1.substr(0, 24) + '...' : m1) + '</a>' + m4;
                });
            },
            at: function (tweet) {
                return tweet.replace(/\B[@＠]([a-zA-Z0-9_]{1,20})/g, function (m, username) {
                    return '<a target="_blank" class="twit-at" href="http://twitter.com/intent/user?screen_name=' + username + '">@' + username + '</a>';
                });
            },
            clean: function (tweet) {
                return this.at(this.link(tweet));
            }
        }
    });
    return {
        Twitter: Twitter
    };
});



/** WEBPACK FOOTER **
 ** ./js/view/components/Twitter.js
 **/